export default {
  type: "clinical_modification",
  config: null
};
//# sourceMappingURL=clinical_modification.js.map